module.exports = __webpack_public_path__ + "media/images/dividend/ill-bike-aed5cf96a47fe7a5ee5aef6021e817ea.svg";